(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SourceDetailController', SourceDetailController);

    SourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Source', 'Infection', 'Corporation'];

    function SourceDetailController($scope, $rootScope, $stateParams, previousState, entity, Source, Infection, Corporation) {
        var vm = this;

        vm.source = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:sourceUpdate', function(event, result) {
            vm.source = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
